import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

export const LANG_STORAGE_KEY = 'lang';
export const LANGS = ['fr', 'en', 'de'] as const;
export type Lang = (typeof LANGS)[number];

export function isLang(value: string | null): value is Lang {
  return value === 'fr' || value === 'en' || value === 'de';
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'de'],
    interpolation: { escapeValue: false },
    // Capability ids are `action:Subject`, and ':' is i18next's default
    // namespace separator — so `profile.identity.caps.read:Photo` was being read
    // as namespace `profile.identity.caps.read`, key `Photo`, and every one of
    // the 18 labels fell back to the raw identifier on screen. There is one
    // namespace here (`translation`), so turning the separator off costs
    // nothing.
    nsSeparator: false,
  });

export default i18n;
